import hash from 'object-hash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { RESPONSE_STATUS } from '../../constnats/general';
import { ListTasksFiltersType, ListTasksFilterWithoutPage, TaskInfoType } from '../../schemas/task.schemas';
import Alert from '../../utils/alert';
import TasksRepo from '../../utils/repository/tasksRepo/tasksRepo';

function useTasks(filters: ListTasksFilterWithoutPage = {}) {
    const [tasks, setTasks] = useState<TaskInfoType[]>([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const memoizedFilters: ListTasksFiltersType = useMemo(() => ({ ...filters, page }), [hash(filters), page]);

    const fetchTasks = useCallback(() => {
        setLoading(true);
        TasksRepo.listTasks(memoizedFilters, (response) => {
            if (response.status === RESPONSE_STATUS.SUCCESS) {
                setTasks(response.data.content);
                setTotalPages(response.data.totalPages);
            } else {
                Alert.warn(response.message);
            }
            setLoading(false);
        });
    }, [memoizedFilters]);

    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);

    return { tasks, loading, refetch: fetchTasks, page, setPage, totalPages };
}

export default useTasks;
